const SESSION_DURATION = 120 // Minutes

import { store } from '../store'
import { ORDER } from '../store/namespace/order/order'
import { ORDER_ITEMS } from '../store/namespace/order/order-items'
import { ORDER_PARTNERS_PACKAGES } from '../store/namespace/partners/order-partners-packages'
import { ORDER_MOVING_PACKAGES } from '../store/namespace/moving/order-moving-packages'

export function saveOrderState() {
  const state = {
    zipCode: store.getters[ORDER.GETTERS.ZIP_CODE],
    currentStep: store.getters[ORDER.GETTERS.CURRENT_STEP],
    activeServiceId: store.getters[`orderServices/activeServiceId`],
    items: store.getters[ORDER_ITEMS.GETTERS.LIST],
    partnerPackageId: store.getters[ORDER_PARTNERS_PACKAGES.GETTERS.ACTIVE_ID],
    partnerAddress: store.getters[ORDER_PARTNERS_PACKAGES.GETTERS.ADDRESS],
    movingPackageId: store.getters[ORDER_MOVING_PACKAGES.GETTERS.ACTIVE_ID],
    movingMeta: store.getters[ORDER.GETTERS.MOVING_META]
  }
  localStorage.setItem('order-saved-state', JSON.stringify(state))
  localStorage.setItem(
    'order-saved-state-datestamp',
    JSON.stringify(Date.now())
  )
}

export async function loadOrderState(
  stateInitializingCallback
) {
  let stateDate = localStorage.getItem('order-saved-state-datestamp')

  if (stateDate) {
    stateDate = parseInt(stateDate)

    const diff = (Date.now() - stateDate) / 1000 / 60

    if (diff > SESSION_DURATION) {
      console.info('STATE CLEARED FOR DURATION')
      clearOrderState()

      return false
    }
  }

  const stateLocal = localStorage.getItem('order-saved-state')

  // TODO: remove awaits

  if (stateLocal) {
    const state = JSON.parse(stateLocal)

    if (stateInitializingCallback) {
      stateInitializingCallback({
        order_type: state.activeServiceId,
        partner_building_address: state.partnerAddress,
        $raw: state
      });
    }

    if (state.movingMeta) {
      store.commit(ORDER.MUTATIONS.SET_MOVING_META, state.movingMeta)
    }

    if (state.activeServiceId && state.activeServiceId === 'partners') {
      await store.dispatch(
        ORDER_PARTNERS_PACKAGES.ACTIONS.INIT_LIST,
        state.partnerAddress
      )

      if (state.partnerPackageId) {
        store.commit(
          ORDER_PARTNERS_PACKAGES.MUTATIONS.SET_ACTIVE_ID,
          state.partnerPackageId
        )
      }
    }

    if (state.activeServiceId && state.activeServiceId === 'moving') {
      await store.dispatch(ORDER_MOVING_PACKAGES.ACTIONS.GET_LIST)

      if (state.movingPackageId) {
        store.commit(
          ORDER_MOVING_PACKAGES.MUTATIONS.SET_ACTIVE_ID,
          state.movingPackageId
        )
      }
    }

    if (state.zipCode) {
      store.commit(ORDER.MUTATIONS.SET_ZIP_CODE, state.zipCode)
    }

    if (state.activeServiceId) {
      store.commit(
        `orderServices/setActiveServiceId`,
        state.activeServiceId
      )
    }

    if (state.partnerAddress) {
      store.commit(
        ORDER_PARTNERS_PACKAGES.MUTATIONS.SET_ADDRESS,
        state.partnerAddress
      )
    }

    if (state.items && state.items.length > 0) {
      store.commit(ORDER_ITEMS.MUTATIONS.SET_LIST, state.items)
    }
    if (state.currentStep) {
      store.commit(ORDER.MUTATIONS.SET_CURRENT_STEP, state.currentStep)
    }
  } else {
    return false
  }
}

export function clearOrderState() {
  localStorage.removeItem('order-saved-state')
  localStorage.removeItem('order-saved-state-datestamp')
}
